import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setPostSignUser = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_SIGNUSER
            });
            if (data.status === 'success') {
                window.location.replace(data.url)
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostSignUser as SetPostSignUser
}